import Slider from '../../../assets/js/components/slider';

export default class SliderPress extends Slider {

	static selector = 'slider-press__container';

}
